import clsx from 'clsx'
import React from 'react'

/**
 * @deprecated Use @trustoo/components/ui/LinearLoader instead
 */
class LinearLoader extends React.Component {
    render() {
        const { fixed } = this.props
        return (
            <div className={clsx('linear-progress-material', fixed && 'fixed')}>
                <div className="bar bar1" />
                <div className="bar bar2" />
            </div>
        )
    }
}

LinearLoader.propTypes = {}

export default LinearLoader
